import typeCheck from 'common/util/typeCheck';

export default function setMapZoomLevel({ state }, zoomLevel) {
  typeCheck('zoomLevel::PositiveNumber', zoomLevel);
  state.set(['listingsMapView', 'mapChanged'], true);
  state.set(['listingsMapView', 'mapZoomLevel'], zoomLevel);
}
